{
    "Accessibility menu": "منوی دسترسی",
    "Reset settings": "بازنشانی تنظیمات",
    "Close": "بستن",
    "Content adjustments": "تنظیمات محتوا",
    "Navigation adjustments": "تنظیمات ناوبری",
    "Align Left": "تراز به چپ",
    "Adjust Font Size": "تنظیم اندازه فونت",
    "Highlight Title": "برجسته کردن عنوان",
    "Highlight Links": "برجسته کردن لینک‌ها",
    "Readable Font": "فونت خوانا",
    "Colour adjustments": "تنظیمات رنگ",
    "Dark Contrast": "کنتراست تاریک",
    "Light Contrast": "کنتراست روشن",
    "High Contrast": "کنتراست بالا",
    "High Saturation": "اشباع بالا",
    "Low Saturation": "اشباع پایین",
    "Monochrome": "تک‌رنگ",
    "Tools": "ابزارها",
    "Reading Guide": "راهنمای خواندن",
    "Stop Animations": "توقف انیمیشن‌ها",
    "Big Cursor": "مؤشر بزرگ",
    "Increase Font Size": "افزایش اندازه فونت",
    "Decrease Font Size": "کاهش اندازه فونت",
    "Letter Spacing": "فاصله بین حروف",
    "Line Height": "ارتفاع خط",
    "Font Weight": "وزن فونت",
    "Dyslexia Font": "فونت دیسلکسیا",
    "Language": "زبان",
    "Accessibility widget": "بازکردن منوی دسترسی",
    "Accessibility Profiles": "پروفایل‌های دسترسی",
    "Cognitive Disability": "ناتوانی شناختی",
    "Seizure Safe": "ایمن برای صرع",
    "Accessibility statement": "بیانیه دسترسی"
}
  